export default __webpack_public_path__ + "static/damper_b.4b8dec17ab01663ac722ace4c62e30f9.png";